/* Cart drawer "Complete your kit" (zcu) + cart de-dupe for the Daylight PDP "Use it with:" rows.
   - Drawer rows are server-rendered by snippets/cart-related-mobile.liquid (already de-duped in Liquid).
   - This file handles colour swatches, size chips, the round bag button, and a second de-dupe pass from /cart.js
     that also hides PDP .drd-co__row entries (via their data-pids) whose product is already in the cart.
   - The drawer re-renders through innerHTML, so everything here is delegated; nothing binds to drawer nodes. */
(function () {
  if (window.__zcuLoaded) return;
  window.__zcuLoaded = true;

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- cart state from /cart.js ---------- */
  var cartIds = null, lastSig = null, cartTimer = null, applyTimer = null;
  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        cartIds = {};
        (c.items || []).forEach(function (i) { cartIds[String(i.product_id)] = 1; });
        apply();
      })
      .catch(function () {});
  }
  function cartSig() {
    var b = document.getElementById('cart-icon-bubble');
    var lines = qa('#CartDrawer tr.cart-item[data-variant-id]').map(function (t) { return t.getAttribute('data-variant-id'); }).join(',');
    return (b ? b.textContent.replace(/\s+/g, '') : '') + '|' + lines;
  }
  function famInCart(el) {
    if (!cartIds) return false;
    return (el.getAttribute('data-pids') || '').split(',').some(function (id) { return id && cartIds[id]; });
  }

  /* ---------- hide anything already in the cart ---------- */
  function apply() {
    if (!cartIds) return;
    qa('.zcu').forEach(function (z) {
      var any = false;
      qa('.zcu-row', z).forEach(function (r) { var hide = famInCart(r); r.hidden = hide; if (!hide) any = true; });
      z.hidden = !any;
    });
    qa('.drd-co').forEach(function (co) {
      if (q('.drd-co__skel', co)) return; /* still loading */
      qa('.drd-co__row[data-pids]', co).forEach(function (r) {
        if (famInCart(r)) r.setAttribute('data-zcu-hide', ''); else r.removeAttribute('data-zcu-hide');
      });
      var g = co.getAttribute('data-drd-g');
      function vis(r) {
        if (r.hasAttribute('data-zcu-hide')) return false;
        if (g === 'm' && r.classList.contains('drd-co-w')) return false;
        if (g === 'w' && r.classList.contains('drd-co-m')) return false;
        return true;
      }
      var any = false, firstOk = null, activeEmpty = false;
      qa('[data-drd-co-tab]', co).forEach(function (t) {
        var p = q('[data-drd-co-panel="' + t.getAttribute('data-drd-co-tab') + '"]', co);
        var has = !!p && qa('.drd-co__row', p).some(vis);
        if (has) { any = true; if (!firstOk) firstOk = t; t.removeAttribute('data-zcu-hide'); }
        else { t.setAttribute('data-zcu-hide', ''); if (t.classList.contains('is-on')) activeEmpty = true; }
      });
      if (any) co.removeAttribute('data-zcu-hide'); else co.setAttribute('data-zcu-hide', '');
      if (activeEmpty && firstOk) firstOk.click();
    });
  }

  /* Any cart change re-renders the drawer or the cart bubble; re-read /cart.js when their contents change. */
  function onMutate(muts) {
    var cartTouched = false;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.closest && t.closest('cart-drawer, #cart-icon-bubble')) { cartTouched = true; break; }
    }
    if (cartTouched) {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () { var s = cartSig(); if (s !== lastSig) { lastSig = s; loadCart(); } else apply(); }, 200);
    } else {
      clearTimeout(applyTimer);
      applyTimer = setTimeout(apply, 80);
    }
  }

  /* ---------- swatches, sizes, bag ---------- */
  function sizeChips(vars, keep) {
    var sel = null;
    var html = vars.map(function (v) {
      var on = v[2] && keep != null && v[1] === keep; if (on) sel = v;
      return '<button type="button" class="zcu-size' + (on ? ' is-on' : '') + (v[2] ? '' : ' is-out') + '" data-vid="' + v[0] + '" data-size="' + esc(v[1]) + '" aria-pressed="' + on + '"' +
        (v[2] ? '' : ' disabled aria-disabled="true"') + ' aria-label="Size ' + esc(v[1]) + (v[2] ? '' : ' (sold out)') + '">' + esc(v[1]) + '</button>';
    }).join('');
    return { html: html, sel: sel };
  }
  function setBag(row, ok, label) {
    var b = q('[data-zcu-add]', row); if (!b) return;
    b.disabled = !ok; b.title = label; b.setAttribute('aria-label', label);
  }
  function rowError(row, msg) {
    var info = q('.zcu-info', row), e = q('.zcu-err', row);
    if (!msg) { if (e) e.remove(); return; }
    if (!e) { e = document.createElement('p'); e.className = 'zcu-err'; info.appendChild(e); }
    e.textContent = msg;
  }

  function add(row, btn) {
    var id = +row.getAttribute('data-id'); if (!id) return;
    rowError(row, null);
    btn.classList.add('is-busy');
    var drawer = q('cart-drawer');
    var secs = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1, sections: secs, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (res.status) { rowError(row, res.description || res.message || 'Could not add this item'); return; }
        btn.classList.add('is-done');
        if (drawer && drawer.renderContents && res.sections) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          catch (err) { if (typeof window.new_updateCartDrawer === 'function') window.new_updateCartDrawer(); }
        } else if (typeof window.new_updateCartDrawer === 'function') {
          window.new_updateCartDrawer();
        }
        lastSig = null; /* force a /cart.js read after the re-render */
        setTimeout(loadCart, 400);
      })
      .catch(function () { btn.classList.remove('is-busy'); rowError(row, 'Could not add this item'); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var sw = e.target.closest('.zcu .zcu-sw');
    if (sw) {
      e.preventDefault();
      var row = sw.closest('.zcu-row');
      qa('.zcu-sw', row).forEach(function (b) { var on = b === sw; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
      var im = q('[data-zcu-img]', row); if (im) { im.src = sw.getAttribute('data-img'); im.alt = sw.getAttribute('data-name'); }
      qa('[data-zcu-link]', row).forEach(function (a) { a.href = sw.getAttribute('data-url'); });
      var nm = q('[data-zcu-name]', row); if (nm) nm.textContent = sw.getAttribute('data-name');
      var pr = q('[data-zcu-price]', row); if (pr) pr.textContent = sw.getAttribute('data-price');
      rowError(row, null);
      if (sw.getAttribute('data-sized') === '1') {
        var vars = []; try { vars = JSON.parse(sw.getAttribute('data-vars') || '[]'); } catch (err) {}
        var holder = q('[data-zcu-sizes]', row);
        if (!holder) { holder = document.createElement('div'); holder.className = 'zcu-sizes'; holder.setAttribute('role', 'group'); holder.setAttribute('aria-label', 'Size'); holder.setAttribute('data-zcu-sizes', ''); q('.zcu-info', row).insertBefore(holder, q('[data-zcu-add]', row)); }
        var c = sizeChips(vars, row.getAttribute('data-size') || null);
        holder.innerHTML = c.html;
        row.classList.add('is-sized');
        row.setAttribute('data-id', c.sel ? c.sel[0] : '');
        row.setAttribute('data-size', c.sel ? c.sel[1] : '');
        setBag(row, !!c.sel, c.sel ? 'Add to cart, size ' + c.sel[1] : 'Select a size');
      } else {
        var h = q('[data-zcu-sizes]', row); if (h) h.remove();
        row.classList.remove('is-sized');
        row.setAttribute('data-id', sw.getAttribute('data-id'));
        row.setAttribute('data-size', '');
        setBag(row, true, 'Add to cart');
      }
      return;
    }
    var chip = e.target.closest('.zcu .zcu-size');
    if (chip) {
      e.preventDefault();
      if (chip.disabled) return;
      var rw = chip.closest('.zcu-row');
      qa('.zcu-size', rw).forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); });
      rw.setAttribute('data-id', chip.getAttribute('data-vid'));
      rw.setAttribute('data-size', chip.getAttribute('data-size'));
      rowError(rw, null);
      setBag(rw, true, 'Add to cart, size ' + chip.getAttribute('data-size'));
      return;
    }
    var bag = e.target.closest('.zcu [data-zcu-add]');
    if (bag) {
      e.preventDefault();
      if (bag.disabled) return;
      add(bag.closest('.zcu-row'), bag);
    }
  });

  function start() {
    lastSig = cartSig();
    loadCart();
    if ('MutationObserver' in window) {
      new MutationObserver(onMutate).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-drd-g'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
